import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { LimitDialogComponent } from './limit-dialog.component';
import { ButtonsModule } from 'src/app/shared/components/buttons/buttons.module';

@NgModule({
  declarations: [LimitDialogComponent],
  imports: [CommonModule, MaterialModule, ButtonsModule],
  exports: [LimitDialogComponent],
  entryComponents: [LimitDialogComponent],
})
export class LimitDialogModule {}
